import OrganizationList from '../../../features/organization/components/OrganizationList'
import NewOragnizationModal from '../../../features/organization/components/NewOrganization/NewOragnizationModal/NewOragnizationModal'
import AddOrgnazationBtnPresenter from '../../../features/organization/components/NewOrganization/AddOrganizationBtn/AddOrganizationBtnPresenter';
import HeaderTitleContent from '../../../common/components/atom/HeaderTitleContent/HeaderTitleContent';
import SectionTitle from '../../../common/components/atom/SectionTitle/SectionTitle';
import PageContent from '../../../common/components/atom/PageContent/PageContent';

/**
 * OrganisationListPage
 * @returns 
 */
export default function OrganizationListPage() {
  return (
    <PageContent>
      <HeaderTitleContent>Organisations</HeaderTitleContent>
      <AddOrgnazationBtnPresenter />
      <div style={{ height: '50px' }} />
      <SectionTitle iconType={'building'}>Liste des organisations</SectionTitle>
      <div style={{ width: '100%', maxWidth: 1000}}>
        <OrganizationList.List pageSize={5} orderBy='organization_name' />
      </div>
      <NewOragnizationModal />
    </PageContent>
  )
}
